import type { IconName } from '../components/Icon';

export interface ServiceContent {
  icon: IconName;
  title: string;
  description: string;
}

export const services: ServiceContent[] = [
    {
      icon: 'DoorOpen',
      title: "Puertas",
      description: "Puertas principales, de patio y portones de aluminio y vidrio, combinando seguridad y una estética moderna. Trabajos garantizados.",
    },
    {
      icon: 'PanelsTopLeft',
      title: "Ventanas",
      description: "Diseño y fabricación de ventanas a medida, fijas, corredizas y abatibles. Aislamiento térmico y estilo para tu hogar.",
    },
    {
      icon: 'Bath',
      title: "Cancelería de Baños",
      description: "Soluciones elegantes y funcionales para tu ducha con vidrio templado de alta resistencia y diseños personalizados.",
    },
    {
      icon: 'Building2',
      title: "Barandales",
      description: "Barandales de aluminio y vidrio para escaleras, balcones y terrazas. Diseños modernos y seguros para cualquier espacio.",
    },
    {
      icon: 'Square',
      title: "Espejos",
      description: "Espejos decorativos y funcionales para baños, habitaciones y espacios comerciales. Cortes a medida y instalación profesional.",
    },
    {
      icon: 'PanelTop',
      title: "Vidrios de Diferentes Espesor",
      description: "Vidrios templados, laminados y flotados en diversos espesores. Calidad garantizada para cualquier aplicación residencial o comercial.",
    },
];
